import React from "react";
import { useNavContext } from "../../context-api/nav-context";
/* import waveOne from "../../Assets/Images/homeGuides/card-wave-1.png";
import waveTwo from "../../Assets/Images/homeGuides/card-wave-2.png"; */

const HomeGuides = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="home-guides" onMouseOver={closeNavbarMenu}>
      <div className="section-wrapper">
        <h2 className="title home-guides-title">Helpful Guides & Articles</h2>
        <div className="home-guides-content-wrapper">
          <div className="home-guides-content-left-col">
            <div className="article-card-big">
              <h3 className="guide-title">The Complete Boiler Buying Guide</h3>
            </div>
          </div>
          <div className="home-guides-content-right-col">
            <div className="article-card-small">
              <div className="article-card-small-content">
                <h5 className="card-small-subtitle">ARTICLE</h5>
                <h4 className="card-small-title">
                  Which Smart Thermostat Should You Pick?
                </h4>
                <p className="card-small-p">
                  With the number of smart thermostats available growing
                  rapidly, knowing which model would suit...
                </p>
              </div>
              <div className="article-card-small-header">
                <img
                  src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1642187276/AquaHeat/Home%20articles/card-wave-1_a4gnix.webp"
                  alt="boiler article"
                />
              </div>
            </div>
            <div className="article-card-small">
              <div className="article-card-small-content">
                <h5 className="card-small-subtitle">ARTICLE</h5>
                <h4 className="card-small-title">
                  Is your boiler going bump in the night?
                </h4>
                <p className="card-small-p">
                  From rattling to gurgling and tapping sounds, boilers can
                  sometimes seem more vocal than we would like...{" "}
                </p>
              </div>
              <div className="article-card-small-header">
                <img
                  src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1642187276/AquaHeat/Home%20articles/card-wave-2_eevoy3.webp"
                  alt="boiler article"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeGuides;
